export interface Tilbakemelding {
	tilbakemeldingspunkter: Tilbakemeldingspunkter[];
	vedlegg: Kompetansebevis[];
}

interface Kompetansebevis {
	id: string;
	filnavn: string;
	mimetype: string;
	storrelse: number;
}

export interface Tilbakemeldingspunkter {
	innhold: string;
	punkt: string;
}

export type Punkter =
	| 'soknadsinformasjon'
	| 'omrade'
	| 'risikoforhold'
	| 'skisse'
	| 'periode'
	| 'kontaktinformasjon'
	| 'tilleggsinformasjon'
	| 'annet';
